import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type Demo } from '@/types';
import i18n from '@/i18n';
import { type DemoInitialState } from './types';

const initialState: DemoInitialState = {
  demo: {
    title: i18n.t('LOADING'),
    description: i18n.t('LOADING'),
  },
};

export const demoSlice = createSlice({
  name: 'demo',
  initialState,
  reducers: {
    setDemo: (state, { payload }: PayloadAction<Demo>) => {
      state.demo = payload;
    },
  },
});

export const { reducer: demoReducer } = demoSlice;
